// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthClosuresDashboard\BerthClosuresDashboardViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthClosure, BerthClosureData, BerthClosureOptions } from 'data/models/BerthClosure';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';

// BerthClosuresDashboardData is the class that BerthClosuresDashboard serializes to/from
export interface BerthClosuresDashboardData {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    ToDate : /* ISO8601 */ string;
	
    Closures : BerthClosureData[] | null;
    Organization : OrganizationData | null;
	
}

// BerthClosuresDashboardOptions is the class which may be passed to the BerthClosuresDashboard constructor to define optional initial data values
export interface BerthClosuresDashboardOptions {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    ToDate : /* ISO8601 */ string;
	
    Closures? : BerthClosureOptions[] | null;
    Organization? : OrganizationOptions | null;
	
}

export class BerthClosuresDashboard {
    public FromDate : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
    public ToDate : DataSignal<TZDate>;
	
    public Closures : SDataArray<BerthClosure>;
    public Organization : DataSignal<Organization | null>;
	

    constructor();
    constructor(data : BerthClosuresDashboardOptions);
    constructor(data: BerthClosuresDashboardOptions | null = null) {
        this.FromDate = jsonableObservable(S.value<TZDate>(data && data.FromDate !== undefined ? new TZDate(data.FromDate) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.ToDate = jsonableObservable(S.value<TZDate>(data && data.ToDate !== undefined ? new TZDate(data.ToDate) : new TZDate(0), TZDate.eq));
	    
        this.Closures = SArray<BerthClosure>([]);
        this.Organization = S.value<Organization | null>(null);
	    
    }

    static key(obj : BerthClosuresDashboard) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.ToDate().toJSON();
    }
    
    static dataKey(obj : BerthClosuresDashboardOptions) {
        return new TZDate(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + new TZDate(obj.ToDate).toJSON();
    }

    static update(obj : BerthClosuresDashboard, data : BerthClosuresDashboardOptions) {
        S.freeze(() => {
            if (data.FromDate !== undefined) obj.FromDate(new TZDate(data.FromDate));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.ToDate !== undefined) obj.ToDate(new TZDate(data.ToDate));
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthClosuresDashboard.ts